import { FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { FooterProps } from './types'
import LegalArea from './shared/legal-area'
import Divider from '../../atoms/divider'
import MainFooterSection from './shared/main-footer-section'

const Footer: FunctionComponent<FooterProps> = ({ legalLinks: legalAreaProps, ...footerProps }) => {
  return (
    <FooterContainer role="contentinfo">
      <MainFooterSection {...footerProps} />
      <Divider />
      <LegalArea links={legalAreaProps} />
    </FooterContainer>
  )
}

const FooterContainer = styled.footer`
  width: 100%;
  padding-block: 3.5rem 0.5rem;
  padding-inline: 4rem;
  background-color: var(--neutral-900);
  color: var(--beige-200);

  @media (max-width: 1279px) {
    padding-inline: 1rem;
  }
`

export * from './types'
export default Footer
